import AesShipmentApiUrls from 'src/apiUrls/AesShipmentApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React, { useContext, useState, useRef } from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { AesTranslationContext } from '../contexts/AESTranslationContext'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import { useLocation } from 'react-router-dom'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification }) {
  const [lookups, setLookups] = useState(null)
  const { getTranslatedText } = useContext(AesTranslationContext)
  const loc = useLocation()

  const onSuccessCallback = useRef((e) =>
    history.push(`${pathMap.AES_SHIPMENT_LIST_VIEW}`)
  )

  function handleSave() {
    onSuccessCallback.current = (e) => {
      history.push(`${pathMap.AES_SHIPMENT}/edit/${e.id}`)
    }
  }

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  function getCountryStateLabel(country, state) {
    if (!lookups || !country || !state) return state

    // Check if country code exists in the lookup
    if (Object.keys(lookups.countries).includes(country)) {
      const result = lookups.countryStates[country].find(
        (countryState) => countryState.intlcode === state
      )

      return result ? result.descriptionEn : state
    } else {
      return state
    }
  }

  let formikPropsData;
  if (loc.state !== undefined) {
    loc.state.modeOfSubmission = 'UI'
    formikPropsData = {
      ...FormProperties.formikProps,
      initialValues: FormProperties.toClientDataFormat(loc.state)
    }
  } else {
    formikPropsData = FormProperties.formikProps
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              getLookupValue={getLookupValue}
              getCountryStateLabel={getCountryStateLabel}
            />
          )}
          formikProps={formikPropsData}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: AesShipmentApiUrls.POST,
            onSuccess: (e) => {
              showNotification('success', getTranslatedText('AES','addSuccessMsg'))
              onSuccessCallback.current(e)
            }
          }}
          renderButtonSection={(loading) => (
            <ButtonSection
              history={history}
              loading={loading}
              onSave={handleSave}
              getTranslatedText={getTranslatedText}
            />
          )}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage

function ButtonSection(props) {
  const { history, loading, onSave, getTranslatedText } = props
  const [confirmDialog, setConfirmDialog] = useState(false)

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton color='secondary' disabled={loading} onClick={() => setConfirmDialog(true)} size='medium'>{getTranslatedText('AES', 'discardButton')}</CngButton>
        </Grid>
        <Grid item xs='auto'>
          <Grid container spacing={2}>
            <Grid item xs='auto'>
              <CngButton color='primary' disabled={loading} type='submit' onClick={onSave} size='medium'>{getTranslatedText('AES', 'saveButton')}</CngButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <AlertDialog
        cancelLabel={getTranslatedText('AES', 'continueEditing')}
        confirmLabel={getTranslatedText('AES', 'yesDiscard')}
        open={confirmDialog}
        onClose={() => setConfirmDialog(false)}
        onCancel={() => setConfirmDialog(false)}
        onConfirm={() => history.push(pathMap.AES_SHIPMENT_LIST_VIEW)}
        title={getTranslatedText('AES', 'discardButton')}
      >
        {getTranslatedText('AES', 'discardMessage')}
      </AlertDialog>
    </>
  )
}